

import { BaseEntity, CommonSettingEntity } from '@m4u-angular/base/entities/BaseEntities';

export class Registration extends BaseEntity
{   
    public RegistrationDate: Date; 
    public Status: number; 
    public Name: string; 
    public CityID: number; 
    public CityPackageID: number; 
    public Street: string; 
    public Building: string; 
    public Email: string; 
    public Phone: string; 
    public AdditionalPhone: string; 
    public Cellular: string; 
    public CrCardNum: string; 
    public CardValid: string; 
    public MeshOption: number; 
    public NetPointNum: number; 
    public ExternalIp: number; 
    public Telefonia: number; 
    public PrivatePaymentRequestID: string; 
    public AddNewTelephoneLine1: boolean; 
    public PhoneNumberForTransfer1: string; 
    public AddNewTelephoneLine2: boolean; 
    public PhoneNumberForTransfer2: string; 
    public ResultCardCode: string; 
    public WifiName: string; 
    public WifiPassword: string; 
    public CreditCardHolderPersonalID: string; 
    public ResultBillID: number; 
	
}



